import { type EnvName, readEnvName } from "@/lib/env";

const ENV_DOT: Record<EnvName, string> = {
  dev: "var(--es-terra-500)",
  integration: "var(--es-terra-500)",
  staging: "oklch(0.78 0.15 90)",
  prod: "oklch(0.7 0.18 145)",
};

const ENV_LABEL: Record<EnvName, string> = {
  dev: "DEV",
  integration: "INT",
  staging: "STAGING",
  prod: "PRODUCTION",
};

export function EnvBadge(): React.ReactElement {
  const env = readEnvName();
  return (
    <span
      data-testid="env-badge"
      className="inline-flex shrink-0 items-center gap-2 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.12em]"
      style={{
        borderColor: "var(--es-border)",
        color: "var(--es-fg-secondary)",
      }}
    >
      <span
        aria-hidden
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: ENV_DOT[env] }}
      />
      {ENV_LABEL[env]}
    </span>
  );
}
